import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer';
export var NotificationDrawerListItem = function NotificationDrawerListItem(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isHoverable = _a.isHoverable,
      isHoverable = _a$isHoverable === void 0 ? true : _a$isHoverable,
      _a$isRead = _a.isRead,
      isRead = _a$isRead === void 0 ? false : _a$isRead,
      _a$onClick = _a.onClick,
      _onClick = _a$onClick === void 0 ? function (event) {
    return undefined;
  } : _a$onClick,
      _a$tabIndex = _a.tabIndex,
      tabIndex = _a$tabIndex === void 0 ? 0 : _a$tabIndex,
      variant = _a.variant,
      props = __rest(_a, ["children", "className", "isHoverable", "isRead", "onClick", "tabIndex", "variant"]);

  return React.createElement("li", Object.assign({}, props, {
    className: css(styles.notificationDrawerListItem, isHoverable && styles.modifiers.hoverable, styles.modifiers[variant], isRead && styles.modifiers.read, className),
    tabIndex: tabIndex,
    onClick: function onClick(e) {
      return _onClick(e);
    }
  }), children);
};